import "@/App.css";
import "lenis/dist/lenis.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { SideNav } from "./components/SideNav";
import { SmoothScroll } from "./components/SmoothScroll";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ComingSoon from "./pages/ComingSoon";
import Contact from "./pages/Contact";
import Shipping from "./pages/Shipping";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <SideNav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/shipping" element={<Shipping />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
